import { useMutation } from 'react-query'

import { updateInvoiceDraft as updateDraft } from '../../../query-api'

export const useUpdateInvoiceDraft = () => {
  const { mutate: update, isLoading: isProcessing, ...rest } = useMutation(updateDraft)

  return { update, isProcessing, ...rest }
}
